import React from 'react';
import PropTypes from 'prop-types';

import {
  DATA_TABLE_SOURCE_LISTING_NOTES,
  DATA_TABLE_VIEW_ID_LISTING_NOTES_ALL,
} from 'common/dataTableConstants';

import SrBox from 'client/components/SrBox';
import SrFlex from 'client/components/SrFlex';
import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrCreateNoteForm, {
  SR_CREATE_NOTE_FORM_THEME_ADOBE,
} from 'client/components/SrCreateNoteForm';
import SrNotesList, {
  SR_LISTING_NOTES,
  SR_NOTES_LIST_THEME_GREYCLIFF,
} from 'client/components/SrNotesList';

const SrAdminListingNotes = ({ listingId, dispatch, currentUser }) => (
  <SrDataTableConnected
    itemsPropName="notes"
    rootViewId={DATA_TABLE_VIEW_ID_LISTING_NOTES_ALL}
    dataSource={DATA_TABLE_SOURCE_LISTING_NOTES}
    initialViewSettings={{
      sort: {
        createdDate: 'desc',
      },
      filter: {
        listingId,
      },
    }}
  >
    {({ notes, reloadItems, dataTableApiState, onInfiniteScrollWrapperRef }) => (
      <>
        <SrBox overflowY="auto" maxHeight="200px">
          <div ref={onInfiniteScrollWrapperRef}>
            <SrNotesList
              type={SR_LISTING_NOTES}
              theme={SR_NOTES_LIST_THEME_GREYCLIFF}
              notes={notes}
              dispatch={dispatch}
              reloadDataTable={(noteId) => {
                reloadItems({
                  count: 1,
                  filter: { 'listingNotes.id': noteId },
                });
              }}
              currentUser={currentUser}
            />
          </div>
        </SrBox>
        <SrCreateNoteForm
          listingId={listingId}
          dispatch={dispatch}
          theme={SR_CREATE_NOTE_FORM_THEME_ADOBE}
          reloadDataTable={(noteId) => {
            reloadItems({
              count: 1,
              filter: { 'listingNotes.id': noteId },
            });
          }}
        />
        {dataTableApiState.inProgress && (
          <SrFlex justify="center">
            <div className="loading-gif" />
          </SrFlex>
        )}
      </>
    )}
  </SrDataTableConnected>
);

SrAdminListingNotes.propTypes = {
  listingId: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired,
};

SrAdminListingNotes.displayName = 'SrAdminListingNotes';

export default SrAdminListingNotes;
